/* Location and Contact */

export function location_and_contact_anchor() {

	( ( $ ) => {

		window.onload = () => {
			// Check if the URL contains '#community-contact-form'
			if ( window.location.hash === '#community-contact-form' ) {

				const form = $( '.mktoForm' );

				// Check if the '.mktoForm' element exists
				if ( form.length <= 0 ) {
					return;
				}

				const target_position = parseInt( form.offset().top - window.COVE.navbar_total_height );

				$( 'html, body' ).animate( {
					scrollTop: target_position
				} );
			}
		};

	} )( window.jQuery );
}
